<template>
  <div class="qmkey-custom-input">
    <component
      v-if="field"
      :is="field.component"
      :ref="field.id"
      :props="field"
      :form_values="form_values"
      @update="update"
      :current_unit="current_unit"
    />
    <!-- HELP BUTTON -->
    
    <v-tooltip
      right
      max-width="30%"
      min-width="0%"
      style="width: fit-content;"
      width="fit-content"
      outlined
      content-class="pa-0"

    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-if="field.help_text"
          class="qmkey-input-help-btn"
          x-small
          v-on="on"
          color="ctas darken-2"
        >
          mdi-help
        </v-icon>
      </template>
      <div class="pa-1 qmkey-input-help-text">{{ field.help_text }}</div>
    </v-tooltip>
  </div>
</template>
    
    
<style lang="scss">
  @import "@/sass/explorer.scss";
  @import "@/sass/modalform.scss";
  .qmkey-custom-input {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .qmkey-input-help-btn {
    position: absolute !important;
    top: 0px;
    right: 0px;
  }
  .qmkey-input-help-text {
    white-space: pre-line;
  }
</style>
    

<script>
 import TextInput from '@/components/inputs/TextInput'
 import Select from '@/components/inputs/Select'
 import DateInput from '@/components/inputs/DateInput'
 import DateTimeInput from '@/components/inputs/DateTimeInput'
 import TextareaInput from '@/components/inputs/TextareaInput'
 import NumericInput from '@/components/inputs/NumericInput'
 import FileInput from '@/components/inputs/FileInput'
 import ProcessDependingUserField from '@/components/inputs/ProcessDependingUserField'
 import DirectoryInput from '@/components/inputs/DirectoryInput'
 import Tag from '@/components/inputs/Tag'
 import AutocompleteSelect from '@/components/inputs/AutocompleteSelect'
 import DynamicSelectInput from '@/components/inputs/DynamicSelectInput'
 import DynamicInput from '@/components/inputs/DynamicInput'
 import TimeEvent from '@/components/inputs/TimeEvent'
 import ComputedInput from '@/components/inputs/ComputedInput'
 import StateInput from '@/components/inputs/StateInput';
 import CheckboxInput from '@/components/inputs/CheckboxInput'
 import GenericTreeviewSelect from '@/components/inputs/GenericTreeviewSelect'
 import TreeviewSelect from '@/components/inputs/TreeviewSelect'
 import IndicatorMetricInput from '@/components/inputs/IndicatorMetricInput';
 import IndicatorTrackingInput from '@/components/inputs/IndicatorTrackingInput';
 import RelatedSelect from '@/components/inputs/RelatedSelect'
 import LinkInput from '@/components/inputs/LinkInput'
 import MetricEdit from '@/components/inputs/MetricEdit';
 import IndicatorRiskInterpreter from '@/components/inputs/IndicatorRiskInterpreter';
 import DictInput from '@/components/inputs/DictInput';
 export default {
   components: {
     TextInput,
     Select,
     DateInput,
     DateTimeInput,
     TextareaInput,
     NumericInput,
     FileInput,
     ProcessDependingUserField,
     DirectoryInput,
     Tag,
     AutocompleteSelect,
     DynamicSelectInput,
     DynamicInput,
     TimeEvent,
     ComputedInput,
     StateInput,
     CheckboxInput,
     TreeviewSelect,
     GenericTreeviewSelect,
     IndicatorMetricInput,
     IndicatorTrackingInput,
     RelatedSelect,
     LinkInput,
     MetricEdit,
     IndicatorRiskInterpreter,
     DictInput,
   },

   name: 'CustomInput',

   props: {
     field: {},
     form_values: {default: ()=> ({})},
     current_unit: {},
   },

   data: () => ({
   }),

   computed: {
     value() {
       // Warning: _computedWatchers is the properti of the computed values of the component
       // we are taking input computed value so it will not accept incorrect initial values
       const ref = this.$refs[this.field.id]
       if (ref) {
         return ((ref._computedWatchers || {}).value || {}).value;
       } else {
         return null;
       }
     },
   },

   mounted() {
   },

   methods: {
     update(value) {
       this.$emit('update',value)
     },
   },

   watch: {
   },
 }
</script>
